import type { ReactNode } from 'react';
import { createContext, useCallback, useContext, useEffect, useState } from 'react';

type RegisterManualEdit = () => () => void;

const RegisterManualEditContext = createContext<RegisterManualEdit | undefined>(undefined);
const HasManualEditsContext = createContext(false);

export const ManualEditsLegendProvider = ({ children }: { children: ReactNode }) => {
    const [markedCount, setMarkedCount] = useState(0);
    const registerManualEdit = useCallback<RegisterManualEdit>(() => {
        setMarkedCount((count) => count + 1);
        return () => setMarkedCount((count) => count - 1);
    }, []);

    return (
        <RegisterManualEditContext.Provider value={registerManualEdit}>
            <HasManualEditsContext.Provider value={markedCount > 0}>{children}</HasManualEditsContext.Provider>
        </RegisterManualEditContext.Provider>
    );
};

export const useManualEditRegistration = (isMarked: boolean) => {
    const registerManualEdit = useContext(RegisterManualEditContext);

    useEffect(() => (isMarked && registerManualEdit ? registerManualEdit() : undefined), [isMarked, registerManualEdit]);
};

export const useHasManualEdits = () => useContext(HasManualEditsContext);
